<template>
  <div class="login-page" style="overflow-x:hidden ">
    <loginCard_desktop
      :isSignIn="true"
      ref="signIn"
      @loginSuccess="loginSuccess"
      class="login-card"
      :type="$route.query.device"
    >
    </loginCard_desktop>
  </div>
</template>

<script>
const devRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: '/app',
    icon: '/home/p__我的实验大icon',
    label: '我的实验',
    title: 'app',
    active: false,
    auth: '3,4,6'
  },
  // {
  //   path: '/review',
  //   icon: '/home/回放',
  //   label: '实验回放',
  //   title: 'review',
  //   active: false,
  //   auth: '4,6',
  // },
  {
    path: 'manager',
    icon: '/home/班级管理',
    label: "班级管理",
    title: "manager",
    active: false,
    auth: '6'
  },
  {
    path: 'apply',
    icon: '/home/班级管理',
    label: "申请学校",
    title: "apply",
    active: false,
    auth: '2'
  }
]


const customRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: 'apply',
    icon: '/home/班级管理',
    label: "申请学校",
    title: "apply",
    active: false,
    auth: '2'
  }
]


const studentRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: '/app',
    icon: '/home/p__我的实验大icon',
    label: '我的实验',
    title: 'app',
    active: false,
    auth: '3,4,6'
  },
  {
    path: 'apply',
    icon: '/home/班级管理',
    label: "申请班级",
    title: "apply",
    active: false,
    auth: '2'
  },
  {
    path: 'report',
    icon: '/home/班级管理',
    label: "实验报告",
    title: "report",
    active: false,
    auth: '2'
  }
]


const teacherRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: '/app',
    icon: '/home/p__我的实验大icon',
    label: '我的实验',
    title: 'app',
    active: false,
    auth: '3,4,6'
  },
  // {
  //   path: '/review',
  //   icon: '/home/回放',
  //   label: '实验回放',
  //   title: 'review',
  //   active: false,
  //   auth: '4,6',
  // },
  {
    path: 'manager',
    icon: '/home/班级管理',
    label: "班级管理",
    title: "manager",
    active: false,
    auth: '6'
  },
  {
    path: 'report',
    icon: '/home/班级管理',
    label: "实验报告",
    title: "report",
    active: false,
    auth: '2'
  }
]


const managerRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: '/app',
    icon: '/home/p__我的实验大icon',
    label: '我的实验',
    title: 'app',
    active: false,
    auth: '3,4,6'
  },
  // {
  //   path: '/review',
  //   icon: '/home/回放',
  //   label: '实验回放',
  //   title: 'review',
  //   active: false,
  //   auth: '4,6',
  // },
  {
    path: 'manager',
    icon: '/home/班级管理',
    label: "班级管理",
    title: "manager",
    active: false,
    auth: '6'
  }
]

import loginCard from '@/components/loginCard'
import NavHeader from '@/components/NavHeader'
import loginCard_desktop from "@/components/loginCard_desktop";
import {getHistory} from "@/api/app";
export default {
  name: 'login_desktop',
  components:{
    NavHeader,
    loginCard_desktop
  },
  layout:'home',
  data(){
    return{

      //控制卡片显隐
      showLoginCard:this.$route.query.way==='登录',

      user_type:'',
      routerlist:'',
      device:'账号',
      signWay:''



    }
  },
  created () {
    if(this.$route.query.way==="注册"){
      this.signWay='注册'
      this.device='手机'
    }
    else {
      this.signWay='登录'
    }
  },
  mounted () {
    console.log(this.$route.query)
    this.signWay=this.$route.query.way
  },
  methods:{
    loginSuccess(way){
      let group = JSON.parse(sessionStorage.getItem('user_type'))
      try{
        if (group.find(item => item.name === '普通用户')) {
          this.user_type = '普通用户'
          this.routerlist = customRouter
        }
        if (group.find(item => item.name === '家长')) {
          this.user_type = '家长'
          this.routerlist = customRouter
        }
        if (group.find(item => item.name === '老师')) {
          this.user_type = '老师'
          this.routerlist = teacherRouter
        }
        if (group.find(item => item.name === '学生')) {
          this.user_type = '学生'
          this.routerlist = studentRouter
        }
        if (group.find(item => item.name === '学校管理员')) {
          this.user_type = '学校管理员'
          this.routerlist = managerRouter
        }
        if (group.find(item => item.name === '管理员')) {
          this.user_type = '管理员'
          this.routerlist = devRouter
        }
        sessionStorage.setItem('user_identity', this.user_type)
        sessionStorage.setItem('router', JSON.stringify(this.routerlist))
      }
      catch (e) {
        console.log(e)
      }
      setTimeout(()=>{
        if(this.user_type!=='普通用户'){
          if(way==='online'){
            sessionStorage.setItem('platform','online')
            this.$router.push('/onlineApp_desktop')
          }
          else{
            sessionStorage.setItem('platform','exam')
            if(this.user_type==='老师'){
              this.$router.push('/teacherExam_desktop')
            }
            if(this.user_type==='学生'){
              this.$router.push('/studentExam_desktop')
            }

          }
        }
        else{
          this.$router.push('/home_desktop')
        }
        // this.$router.push({name:'home',params:{account:arguments[0]}})

      },500)
    },
    createSuccess(){
      setTimeout(()=>{
        this.$router.push({name:'home',params:{account:arguments[0]}})
      },500)
    },

  }
}
</script>

<style scoped>
.login-page{
  width: 100vw;
  height: 100vh;
  background-image: url("http://data.xiyilab.com/web/main/static/login/图层6.png");
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover ;
  overflow: hidden;
}
.login-card{
  width: 23vw;
  height: 32vw;
  margin-top: 11vw;
  margin-left: 60vw;
  margin-bottom: 12vw;
}
</style>
